import { render, staticRenderFns } from "./news-detail.vue?vue&type=template&id=2cdddc5a&scoped=true&"
import script from "./news-detail.vue?vue&type=script&lang=js&"
export * from "./news-detail.vue?vue&type=script&lang=js&"
import style0 from "./news-detail.vue?vue&type=style&index=0&id=2cdddc5a&lang=scss&scoped=true&"
import style1 from "./news-detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdddc5a",
  null
  
)

export default component.exports